import { useUser } from '@clerk/nextjs';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_NOTIFICATIONS_KEY } from '@web-app/hooks/consts';
import { trpc } from '@web-app/utils/trpc';
import { useEffect } from 'react';

const UNREAD_LABS_STALE_MS = 30_000;

/** Patients with a confirmed lab this provider has not opened yet. */
export function useUnreadLabs(enabled = true) {
  const { user, isLoaded } = useUser();
  const queryClient = useQueryClient();

  // viewerId keys the cache per signed-in user. Without it, a same-tab Clerk
  // switch reuses the previous provider's badge and deep-link patient.
  // The server ignores viewerId. Wait for Clerk so the first request is not
  // stored under an empty id.
  const query = trpc.prescriptionReviewV2.unreadLabs.useQuery(
    { viewerId: user?.id ?? '' },
    {
      enabled: enabled && isLoaded && Boolean(user?.id),
      staleTime: UNREAD_LABS_STALE_MS,
      refetchOnWindowFocus: true,
    },
  );

  useEffect(
    function refreshNotificationCenterAfterLabCount() {
      if (query.data == null) return;
      void queryClient.invalidateQueries({
        queryKey: [QUERY_NOTIFICATIONS_KEY],
      });
    },
    [query.data, query.dataUpdatedAt, queryClient],
  );

  return query;
}
